<template>
<div class="ravenhub-notification-wrapper">
  <div class="open-feed show" :class="(isOpen ? 'activeBell' : 'inactiveBell')" v-click-outside="closeNotificationCenter">
    <div @click="toggleChatOpen">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 32.5" version="1.1" x="0px" y="0px"><g stroke="none" stroke-width="1" fill="inherit" fill-rule="evenodd"><g transform="translate(-8.000000, -6.000000)" fill="inherit"><g><g transform="translate(8.000000, 6.000000)"><path d="M16.5831819,20.169 L5.27318192,20.169 L2.10718192,20.169 C3.52618192,18.18 4.55018192,16.711 4.77118192,16.369 C4.85618192,16.238 4.96118192,16.06 5.05318192,15.826 C5.07518192,15.771 5.14118192,15.599 5.19418192,15.361 C5.23818192,15.162 5.28318192,14.877 5.27318192,14.527 L5.27318192,9.363 C5.27318192,6.583 7.52718192,4.33 10.3081819,4.33 L11.5491819,4.33 C14.3291819,4.33 16.5831819,6.583 16.5831819,9.363 L16.5831819,14.527 C16.5731819,14.877 16.6171819,15.162 16.6621819,15.361 C16.7151819,15.599 16.7811819,15.771 16.8031819,15.826 C16.8951819,16.06 17.0001819,16.238 17.0851819,16.369 C17.3061819,16.711 18.3291819,18.18 19.7491819,20.169 L16.5831819,20.169 Z M10.9351819,23.381 C9.97918192,23.381 9.17718192,22.746 8.90518192,21.878 L12.9641819,21.878 C12.6911819,22.746 11.8901819,23.381 10.9351819,23.381 Z M10.9351819,1.7 C11.6441819,1.7 12.2521819,2.123 12.5311819,2.728 C11.9021819,2.597 10.7401819,2.438 9.33718192,2.729 C9.61618192,2.123 10.2261819,1.7 10.9351819,1.7 Z M21.6441819,19.908 L18.5391819,15.461 C18.3941819,15.252 18.3151819,15.008 18.3151819,14.758 L18.3151819,9.013 C18.2731819,8.374 18.0481819,6.132 16.2411819,4.504 C15.5931819,3.919 14.9181819,3.575 14.3871819,3.368 C14.3361819,1.501 12.8131819,-5.68434189e-14 10.9351819,-5.68434189e-14 C9.05518192,-5.68434189e-14 7.53318192,1.501 7.48218192,3.368 C6.93018192,3.596 6.17518192,3.995 5.46218192,4.697 C3.81918192,6.316 3.59718192,8.368 3.55318192,9.013 L3.55318192,14.758 C3.55318192,15.008 3.47618192,15.252 3.33018192,15.461 L0.225181922,19.908 C-0.362818078,20.751 0.269181922,21.878 1.32918192,21.878 L7.16218192,21.878 C7.46518192,23.694 9.03218192,25.081 10.9351819,25.081 C12.8361819,25.081 14.4031819,23.694 14.7071819,21.878 L20.5391819,21.878 C21.6001819,21.878 22.2321819,20.751 21.6441819,19.908 Z"/></g></g></g></g></svg>
    </div>
    <span class="badge badge-notify" :class="(unreadNotificationCount > 0 ? 'show' : 'hide')">{{unreadNotificationCount}}</span>
    <div class="feed-container" :class="(isOpen ? 'show' : 'hide')">
      <div class="feed-window">
        <div class="notification-center-header">
            <div class="notification-title">{{pageTitle}}
              <div class="settings-link">
                <div @click="toggleControlPanelOpen">
                <svg xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="16px" y="16px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" fill="inherit" xml:space="preserve"><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><path d="M94.8,40.8L84.2,39c-0.6-1.9-1.4-3.7-2.3-5.5l6.2-8.7c0.9-1.3,0.8-3.1-0.3-4.2l-8.5-8.5c-1.1-1.1-2.9-1.3-4.2-0.3    l-8.7,6.2c-1.7-0.9-3.6-1.7-5.5-2.3L59.2,5.2c-0.3-1.6-1.6-2.7-3.2-2.7H44c-1.6,0-2.9,1.1-3.2,2.7L39,15.8    c-1.9,0.6-3.7,1.4-5.5,2.3l-8.7-6.2c-1.3-0.9-3.1-0.8-4.2,0.3l-8.5,8.5c-1.1,1.1-1.3,2.9-0.3,4.2l6.2,8.7    c-0.9,1.7-1.7,3.6-2.3,5.5L5.2,40.8c-1.6,0.3-2.7,1.6-2.7,3.2v12c0,1.6,1.1,2.9,2.7,3.2L15.8,61c0.6,1.9,1.4,3.7,2.3,5.5l-6.2,8.7    c-0.9,1.3-0.8,3.1,0.3,4.2l8.5,8.5c1.1,1.1,2.9,1.3,4.2,0.3l8.7-6.2c1.7,0.9,3.6,1.7,5.5,2.3l1.8,10.6c0.3,1.6,1.6,2.7,3.2,2.7h12    c1.6,0,2.9-1.1,3.2-2.7L61,84.2c1.9-0.6,3.7-1.4,5.5-2.3l8.7,6.2c1.3,0.9,3.1,0.8,4.2-0.3l8.5-8.5c1.1-1.1,1.3-2.9,0.3-4.2    l-6.2-8.7c0.9-1.7,1.7-3.6,2.3-5.5l10.6-1.8c1.6-0.3,2.7-1.6,2.7-3.2V44C97.5,42.4,96.4,41.1,94.8,40.8z M50,67.1    c-9.5,0-17.1-7.7-17.1-17.1c0-9.5,7.7-17.1,17.1-17.1S67.1,40.5,67.1,50C67.1,59.5,59.5,67.1,50,67.1z"/></g></switch></svg>
                </div>
              </div>
            </div>
        </div>
        <div ref="chatArea" class="feed-area" :class="(isControlPanelOpen ? 'hide' : 'show')" :style="{background: messageBackgroundColorProp}">
          
          <b-card v-for="message in notificationList" :key="message.messageId" border-variant="light" :class="(message.status == 'Unread' ? 'unread' : 'read')">
            
            <b-card-text class="message-body">{{ message.messageText }}</b-card-text>

            <b-button :href="message.btn1Url" 
                      size="sm" 
                      :variant="message.btn1DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button" 
                      v-show="message.showBtn1"
                      @click="registerButtonClick(message, 'btn1')">
              {{message.btn1Label}}
            </b-button>
            <b-button :href="message.btn2Url" 
                      size="sm" 
                      :variant="message.btn2DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button" 
                      v-show="message.showBtn2"
                      @click="registerButtonClick(message, 'btn2')">
              {{message.btn2Label}}
            </b-button>
            <b-button :href="message.btn3Url" 
                      size="sm" 
                      :variant="message.btn3DisplayAs == 'Button' ? 'info' : 'link'" 
                      class="buttons-left raven-action-button" 
                      v-show="message.showBtn3"
                      @click="registerButtonClick(message, 'btn3')">
              {{message.btn3Label}}
            </b-button>

            <template v-slot:footer>            
              <small><timeago class="text-muted" id="timeago-component" :datetime="message.rawtime" :auto-update="60" v-b-tooltip.hover.right="message.formattedTime"></timeago></small>
              <div :class="(message.status == 'Unread' ? 'unread-status' : 'read-status')"><small>{{message.status}}</small></div>
            </template>
          </b-card>
        </div>        

        <div class="control-panel-area" :class="(isControlPanelOpen ? 'show' : 'hide')">
          <control-panel :appid="appid" :subscriberid="subscriberid" fontcolor="#000" ></control-panel>
        </div>
        <div class="notification-center-footer" @click="goToRavenhub">
            <div class="text-muted">
              <small>Powered by ravenhub.io</small>
            </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
</template>

<script>
import ControlPanel from '@/components/ControlPanel.vue';
import ClickOutside from 'vue-click-outside';
var moment = require('moment');
var Parse = require('parse');

Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;


const emojiUnicode = require("emoji-unicode");
const toEmoji = require("emoji-name-map")
console.log(emojiUnicode);


export default {
  name: 'NotificationCenter',
  inheritAttrs: false,
  
  props: {
    appid : String, 
    subscriberid : String,
    iconColorProp: {
      type: String,
      default: '#e6e6e6'
    },
    messageBackgroundColorProp: {
      type: String,
      default: '#ffffff'
    },
    messageOutColorProp: {
      type: String,
      default: '#3d7e9a'
    },
    messageInColorProp: {
      type: String,
      default: '#f1f0f0'
    },
    messageListProp: Array,
    initOpenProp: Boolean
  },
  components: {
    ControlPanel
  },
  directives: {
    ClickOutside
  },
  data: () => {
    return {
      notificationList: [],
      isOpen: false,
      isControlPanelOpen : false,
      subscriberObj : {},
      latestNotification : "",
      latestOpening : "",
      unreadNotificationCount : 0,
      pageTitle: "Notifications"
    }
  },
  created() {
    console.log('created');
    
    this.fetchNotifications();
  },
  mounted() {
    this.isOpen = this.initOpenProp || false
    if (this.messageListProp) {
      this.messageScroll()
    }
    this.isControlPanelOpen = false;
  },

  methods: {
    fetchNotifications() {
      console.log('appId = ', this.appid);
      console.log('subscriberid = ' + this.subscriberid);
      //const Company = Parse.Object.extend('Company');
      const Subscriber = Parse.Object.extend('Subscriber');
      const AppMessage = Parse.Object.extend("AppMessage");
    
      const subsriberQuery = new Parse.Query(Subscriber);
      subsriberQuery.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.appid });
      subsriberQuery.equalTo("SubscriberId", this.subscriberid);
      subsriberQuery.first()
      .then((subscriberResult) => {
        console.log('sub result = ' + subscriberResult);
        if (typeof subscriberResult === 'undefined') {
          console.log('subscriber undefined!');
          // Send async request to create subscriber on serverless
          this.createNewSubscriber();
          return;
        }
        this.subscriberObj = subscriberResult;
        this.latestOpening = subscriberResult.get("LastOpenedNotifications");
        const query = new Parse.Query(AppMessage);
        query.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.appid });
        
        query.equalTo("SubscriberId", subscriberResult);
        query.notEqualTo("Status", "Dismissed");
        query.descending("createdAt");
        query.limit(25);
        query.find()
        .then((appMessageList) => {
          if (appMessageList.length > 0) {
            this.latestNotification = appMessageList[0].get("createdAt");
            this.wrapNotifications(appMessageList);

            // Get badge number
            const badgeQuery = new Parse.Query(AppMessage);
            badgeQuery.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.appid });
            badgeQuery.equalTo("SubscriberId", subscriberResult);
            badgeQuery.greaterThan("createdAt", this.latestOpening);
            badgeQuery.count().then((countResult) => {
              this.unreadNotificationCount = countResult;
            });
          } else {
            // Start fresh
            //this.createNewSubscriber();
          }
          
          // SETUP LIVE QUERY
          let LiveQueryClient = Parse.LiveQueryClient;
          console.log(process.env.VUE_APP_PARSE_LIVE_QUERY_SERVER_URL);
          let client = new LiveQueryClient({
            applicationId: process.env.VUE_APP_PARSE_APP_ID,
            serverURL: process.env.VUE_APP_PARSE_LIVE_QUERY_SERVER_URL,
            javascriptKey: process.env.VUE_APP_PARSE_JS_KEY
          });
          console.log(JSON.stringify(client));
          client.additionalProperties = false;
          console.log('one more time: ' + JSON.stringify(client));
          client.open();
          
          let subscription = client.subscribe(query);
          console.log('sub info: ' + JSON.stringify(subscription));

          subscription.on('create', (obj) =>
          {
            console.log('create', obj.attributes);
            let originalMessage = obj.get('Body');
            let mergedMessage = this.emojiMerge(originalMessage);
            let jsonObj = obj.toJSON();
            let rawTimeStamp = jsonObj.createdAt;
            let curWrapper = this.wrapMessage(mergedMessage, rawTimeStamp, obj);
            this.notificationList.unshift(curWrapper);
            this.unreadNotificationCount++;
            
          });
        }), (error) => {
          console.error('Error when fetching event type list: ' + error);
        }
      }, (error) => {
        console.log('Error fetching subscriber. Need to create one fresh - ' + error);
        this.createNewSubscriber();
      });
      
    },

    emojiMerge(originalMessage) {
      let mergedMessage = originalMessage;
      console.log('orig message = ' + originalMessage);
      const re = /:[^:\s]*(?:::[^:\s]*)*:/gi;
      if (re.test(originalMessage)) {
        var emojiAlphas = [...originalMessage.match(re)];
        
        if (emojiAlphas) {
          for (const cur of emojiAlphas) {
            
            if (toEmoji.get(cur)) {
              mergedMessage = originalMessage.replace(new RegExp(cur, 'g'), toEmoji.get(cur));
            }
          }
        }
      }
      return mergedMessage;
    },

    wrapMessage(messageToWrap, timeval, messageObj) {
      
      let curWrapper = {
        messageId : messageObj.id,
        messageText : messageToWrap,
        status : messageObj.get('Status'),
        rawtime : timeval,
        formattedTime : moment(timeval).format('MMM DD YYYY hh:mmA'),
        showBtn1 : false,
        showBtn2 : false,
        showBtn3 : false
      }
      if (messageObj.get('Button1Label')) {
        curWrapper['showBtn1'] = true;
        curWrapper['btn1Label'] = messageObj.get('Button1Label');
        curWrapper['btn1Url'] = messageObj.get('Button1Url');
        curWrapper['btn1DisplayAs'] = messageObj.get('Button1DisplayAs');
      }
      if (messageObj.get('Button2Label')) {
        curWrapper['showBtn2'] = true;
        curWrapper['btn2Label'] = messageObj.get('Button2Label');
        curWrapper['btn2Url'] = messageObj.get('Button2Url');
        curWrapper['btn2DisplayAs'] = messageObj.get('Button2DisplayAs');
      }
      if (messageObj.get('Button3Label')) {
        curWrapper['showBtn3'] = true;
        curWrapper['btn3Label'] = messageObj.get('Button3Label');
        curWrapper['btn3Url'] = messageObj.get('Button3Url');
        curWrapper['btn3DisplayAs'] = messageObj.get('Button3DisplayAs');
      }
      return curWrapper;
    },

    wrapNotifications(listToWrap) {
      this.notificationList = [];
      listToWrap.forEach(cur => {
        let originalMessage = cur.get('Body');
        let mergedMessage = this.emojiMerge(originalMessage);
        let jsonObj = cur.toJSON();

        let curWrapper = this.wrapMessage(mergedMessage, jsonObj.createdAt, cur);

        this.notificationList.push(curWrapper);
      });
    },

    toggleChatOpen() {
      this.isOpen = !this.isOpen
      this.unreadNotificationCount = 0;
      this.setMessagesToRead();
      this.setSubscriberLastOpened();
    },

    setMessagesToRead() {
      let messagesToUpdate = [];
      this.notificationList.forEach(cur => {
        if (cur.status == 'Unread') {
          var curMessage = new Parse.Object("AppMessage", {
            "objectId": cur.messageId,
            "Status": "Read",
            "SeenTime" : new Date()
          });
          if (cur.showBtn1) {curMessage.set("Button1Status", "Seen")}
          if (cur.showBtn2) {curMessage.set("Button2Status", "Seen")}
          if (cur.showBtn3) {curMessage.set("Button3Status", "Seen")}
          messagesToUpdate.push(curMessage);
        }        
      });
      if (messagesToUpdate.length > 0) {
        Parse.Object.saveAll(messagesToUpdate).then((response) => {
          console.log('Updated read status', response);
        }, (error) => {
          console.log('Failed to update read status', error);
        });
      } else {
        console.log('nothing to update');
      }
    },

    registerButtonClick(messageObj, buttonNum) {
      let clickTime = new Date();
      var curMessage = new Parse.Object("AppMessage", {
            "objectId": messageObj.messageId,
            "LastClickTime" : clickTime
      });
      if (buttonNum == "btn1") {
        curMessage.set("Button1ClickTime", clickTime);
        curMessage.set("Button1Status", "Clicked");
      }
      if (buttonNum == "btn2") {
        curMessage.set("Button2ClickTime", clickTime);
        curMessage.set("Button2Status", "Clicked");
      }
      if (buttonNum == "btn3") {
        curMessage.set("Button3ClickTime", clickTime);
        curMessage.set("Button3Status", "Clicked");
      }
      curMessage.save().then((response) => {
        console.log("Updated click time: " + response);
      }, (error) => {
        console.log('Failed to update click time', error);
      });      
    },

    setSubscriberLastOpened() {
      console.log('***** sub obj = ' + JSON.stringify(this.subscriberObj));
      try {
        this.subscriberObj.set('LastOpenedNotifications', new Date());
        this.subscriberObj.save().then((response) => {
          console.log('Updated Subscriber', response);
        }, (error) => {
          console.error('Error while updating Subscriber', error);
        });
      } catch (errorObj) {
        //console.error('Error while updating Subscriber', errorObj);
      }
    },

    toggleControlPanelOpen() {
      this.isControlPanelOpen = !this.isControlPanelOpen;
      this.pageTitle = this.isControlPanelOpen ? 'Settings' : 'Notifications';
      console.log('toggling control panel = ' + this.isControlPanelOpen);
    },

    closeNotificationCenter() {
      this.isOpen = false;
      console.log('closing');
    },

    messageScroll() {
      let messageDisplay = this.$refs.chatArea
      messageDisplay.scrollTop = messageDisplay.scrollHeight
    },

    createNewSubscriber() {
      const axios = require('axios');
      const createSubscriberEndpoint = 'https://api.ravenhub.io/company/' + this.appid + '/subscribers/' + this.subscriberid;
      axios.post(createSubscriberEndpoint, {})
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    goToRavenhub() {
      window.location = 'https://ravenhub.io';
    }


  }
  
}
</script>

<style scoped lang="scss">
  ::v-deep {
   @import '@/assets/css/ravenhub-custom.scss';
  }
  * {
    box-sizing: border-box;
  }
  .b-tooltip {
    z-index:10001;
  }
  .notification-center-header {
    text-align:center;
    padding: 10px 8px 8px 0px;
    border-bottom: 2px solid #a0a0a0;
    color:#516cf0;
    font-weight: bold;
  }
  .notification-center-footer {
    text-align:center;
    padding: 10px 8px 8px 0px;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid #a0a0a0;
  }
  .settings-link {
    float:right;
    width:16px;
  }
  .settings-link svg {
    fill:#000;
    color: #000;
  }
  .notification-title {
    font-size:inherit;
  }
  .message-container {
    padding: 16px 0 10px 0;
    background: #FFF;
    border: 1px solid #e8e8e8;
  }
  .message-container:hover {
    background: #e8e8e8;
  }
  .message-body {
    text-align: left;
    font-size: 0.9em;
    padding: 0px 0 9px 10px;
    white-space: pre-wrap;
  }
  .message-timestamp {
    text-align: right;
    font-size: 0.8em;
    color: grey;
    padding-right: 5px;
  }
  .headline {
    text-align: center;
    font-weight: 100;
    color: white;
  }
  .feed-container {
    position: absolute;
    right: 10px;
    max-width: 450px;
    min-width: 450px;
    z-index: 10000;
    transform: scale(0);
    font-family: "Avenir", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    background-color:#FFF;
  }
  .feed-container.show {
    animation: scaleIn .15s ease-in-out 0s 1 normal forwards;
  }
  .feed-container.hide {
    display: none;
  }
  .control-panel-area.show {
    animation: scaleIn .15s ease-in-out 0s 1 normal forwards;
    overflow:scroll;
  }
  .control-panel-area.hide {
    display: none;
  }
  .feed-window {
    display: flex;
    flex-direction: column;
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.1);
    width: 100%;
  }
  .feed-area {
    border-radius: 3px 3px 0 0;
    min-height: 300px;
    max-height: 450px;
    position: relative;
    overflow: auto;
    width: 100%;
  }
  .feed-area.show {
    animation: scaleIn .15s ease-in-out 0s 1 normal forwards;
  }
  .feed-area.hide {
    display:none;
  }
  .message {
    width: 45%;
    border-radius: 10px;
    padding: .5em;
    font-size: .8em;
  }
  .message-out {
    color: #ffffff;
    margin-left: 50%;
  }
  .message-in {
    background: #f1f0f0;
    color: black;
  }
  .chat-inputs {
    display: flex;
    justify-content: space-between;
  }
  .chat-input input {
    border: none;
    font-size: .8em;
    outline: none;
    padding: 1.5em;
    width: 90%;
  }
  .chat-form {
    background: #ffffff;
    border-top: 1px solid #e9e9e9;
    border-radius: 0 0 3px 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    width: 100%;
  }
  .submit {
    -webkit-appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
  }
  .submit:focus {
    outline: none;
  }
  .submit-icon {
    width: 20px;
  }
  .close-feed {
    position: absolute;
    right: -40px;
    top: -40px;
    width: 35px;
    border-radius: 50%;
    height: 35px;
    background: #f7f7f7;
    cursor: pointer;
    transform: scale(0);
  }
  .feed-container.show .close-feed {
    animation: scaleIn .15s ease-in-out .3s 1 normal forwards;
  }
  .close-feed svg {
    position: relative;
    left: -1px;
    top: 6px;
    width: 20px;
  }
  .open-feed {
    width: 24px;
    right: 50px;
    top: 25px;
    cursor: pointer;
    z-index: 900;
    transform: scale(0);
  }
  .open-feed.show {
    animation: scaleIn .15s ease-in-out .15s 1 normal forwards;
  }
  .open-feed.activeBell svg{
    fill:#516cf0;
  }
  .open-feed.inactiveBell svg {
    fill:#000;
  }
  .badge {
    display: inline-block;
    padding: .25em .4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25rem;
    color:white;
    font-family: "Avenir", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .badge-notify {
    background: #516cf0;
    position: absolute;
    top: -8px;
    left: 13px;
  }
  .badge-notify.hide {
    display:none;
  }
  .card {
    margin:8px;
    box-shadow:0px 0px 10px -4px #607D8B;
  }
  .card-footer {
    padding: 0.25rem 1.25rem;
  }
  .unread >>> .card-body {
    
    background: #85cef921;
  }
  .unread-status {
    float:right;
    color:#516cf0;
  }
  .read-status {
    display:none;
  }
  .dismiss-position {
    position: absolute;
    right: 8px;
    top: 8px;
    height: 14px;
    color:#98969a;
  }
  .raven-action-button {
    margin-right:5px;
  }
  .btn-link {
    font-weight: bold;
    color: #6c757d;
    text-decoration: none;
  }
  .btn-link:hover {
    color:#b2acfa;
    text-decoration: none;
  }
  .btn-link:focus {
    text-decoration: none;
  }
  @keyframes scaleIn {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
</style>